import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './CucumberPage.css';
import cucumberLogo from '../images/cucumber-logo.png';
import amoghCucumber from '../images/cucumber-amogh-img.png';

const varieties = [

  {
    name: 'AMOGH',
    image: amoghCucumber,
    description: [
      'Vigorous plant development with strong branches and high yield potential',
      'Easy to grow and adapts well to varied growing conditions',
      'Recommended for tropical climate and year-round production',
      'Maturity: 38-40 days',
      'Fruit colour: Medium to dark green with high shape and size uniformity',
      'Fruit size: 18-20 cm length and 4-5 cm diameter',
      'Resistance (IR): Tomato Leaf Curl New Delhi Virus (ToLCNDV)',
      'Vigor: Very strong',
    ],
  },
];

export default function CucumberPage() {
  return <ProductPatternPage title="Cucumber" varieties={varieties} pageClass="cucumber-page" heroImage={cucumberLogo} />;
}
